import { render, staticRenderFns } from "./UploadFiles.vue?vue&type=template&id=7a9906ae&scoped=true"
import script from "./UploadFiles.vue?vue&type=script&lang=js"
export * from "./UploadFiles.vue?vue&type=script&lang=js"
import style0 from "./UploadFiles.vue?vue&type=style&index=0&id=7a9906ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9906ae",
  null
  
)

export default component.exports